import { parsePhoneNumber } from 'libphonenumber-js/min';

export const parseFormattedPhoneNumberIntoPhoneNumber = (value: string) =>
    parsePhoneNumber(value, 'PL').nationalNumber;
